import ptMessages from './locales/pt_BR';

export default ptMessages;
